export const Loading = () => {
    return (
        <div className="loader-sm-loading mx-auto text-center"></div>
    )
}